// Plain-English labels for credit-report statuses — staff should never see
// internal words like "parsed" or "needs_manual". Scoped by `kind` because this
// pill also renders invoice/client/company statuses where words like "pending"
// mean something else entirely (a pending INVOICE is not "Uploading…").
const REPORT_LABELS: Record<string, string> = {
  parsed: "Uploaded",
  needs_manual: "Needs review",
  failed: "Upload failed",
  pending: "Uploading…",
  importing: "Uploading…",
};

export function StatusPill({ status, kind }: { status: string; kind?: "report" }) {
  const normalized = status.toLowerCase().replace(/[\s_]+/g, "-");
  const humanLabel =
    (kind === "report" ? REPORT_LABELS[status.toLowerCase()] : undefined) ??
    status.replace(/_/g, " ");
  return (
    <span
      className={`status-pill ${normalized}`}
      role="status"
      aria-label={`Status: ${humanLabel}`}
    >
      {humanLabel}
    </span>
  );
}
